import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { WidgetWhoIsOnline } from "../Widgets/WidgetWhoIsOnline";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { OnlineUserManager } from "../../../Common/OnlineUserManager";

export type WidgetWhoIsOnlineComponentProps = {
    widget: WidgetWhoIsOnline;
    title: LanguageString;
}

export class WidgetWhoIsOnlineComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetWhoIsOnlineComponentProps;
    onlineConnection: signalR.HubConnection;

    constructor(props: WidgetWhoIsOnlineComponentProps) {
        super(props);
    }

    public ulElement: HTMLElement = <ul class="list-group list-group-flush"></ul>

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO who-online-widget">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.title[`value${app.languageUpperCase}`] && this.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.title[`value${app.languageUpperCase}`] : this.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
            </div>
            <div className="content-row">
                <div className="container overflow-auto pb-3 who-online-list">
                </div>
            </div>
        </div>;

    public render(): HTMLElement {
        this.props.widget.setGridPosition();
        (app.onlineUserManager as OnlineUserManager).requestUpdate();
        return this.element;
    }
}